import React from 'react'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import * as UI from 'ui'
import { SubmitButton } from 'ui'
import { useValue, WhenModelValue } from '@morningtrain/react-resources'
import BackToOverview from 'widgets/navigation/BackToOverview'

export default function EditTemplateHeader () {
  const categoryName = useValue('name')

  return (
    <Translator namespace='cleaning'>
      <UI.PageHeader title={
        <>
          <WhenModelValue name='name'>
            <Translation name='titles.edit_template_name' data={{ category: categoryName }} />
          </WhenModelValue>
          <WhenModelValue name='name' negate>
            <Translation name='titles.edit_template' />
          </WhenModelValue>
        </>
      }
      >
        <UI.ButtonWrap>
          <Can permission={Permissions.CLEANING_CHECKUPS_MANAGE}>
            <BackToOverview route='app.cleaning.templates'>
              <Translation name='actions.back_to_overview' />
            </BackToOverview>
            <SubmitButton>
              <Translation name='actions.save_template' />
            </SubmitButton>
          </Can>
        </UI.ButtonWrap>
      </UI.PageHeader>
    </Translator>
  )
}
